import React, { createContext, useContext, useState, useEffect, ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';

interface RecruiterContextProps {
    isRecruiter: boolean;
    isLoggedIn: boolean | null;
    setIsLoggedIn: (isLoggedIn: boolean) => void;
    userId: string | null;
    onBoarded: boolean | null;
    email: string | null;
    unread: number | 0;
}

const RecruiterContext = createContext<RecruiterContextProps | undefined>(undefined);

export const RecruiterProvider = ({ children }: { children: ReactNode }) => {
    const [isRecruiter, setIsRecruiter] = useState(false);
    const [isLoggedIn, setIsLoggedIn] = useState<boolean | null>(null);
    const [userId, setUserId] = useState<string | null>(null);
    const [onBoarded, setOnBoarded] = useState<boolean | null>(null);
    const [email, setEmail] = useState<string | null>(null);
    const [unread, setUnread] = useState<number>(0);
    const navigate = useNavigate();

    useEffect(() => {
        const checkAuth = async () => {
            try {
                const response = await fetch('/api/user/status'); // Replace with your backend's auth check endpoint
                const data = await response.json();
                if (response.ok) {
                    setIsLoggedIn(true);
                    setIsRecruiter(data.user.Isrecruiter); // Set the isRecruiter state
                    setUserId(data.user.ID);
                    setOnBoarded(data.user.Onboarding);
                    setEmail(data.user.Email);
                    console.log(data);
                    setUnread(data.unread);
                } else {
                    setIsLoggedIn(false);
                    if (window.location.pathname !== '/' && window.location.pathname !== '/login' && window.location.pathname !== '/resume-to-jobs-path') {
                        navigate('/login');
                    }
                }
            } catch (error) {
                console.error('Error checking authentication:', error);
                setIsLoggedIn(false);
            }
        };

        checkAuth();
    }, [navigate]);

    return (
        <RecruiterContext.Provider value={{ isRecruiter, isLoggedIn, userId, setIsLoggedIn, onBoarded, email, unread }}>
            {children}
        </RecruiterContext.Provider>
    );
};

export const useRecruiter = () => {
    const context = useContext(RecruiterContext);
    if (context === undefined) {
        throw new Error('useRecruiter must be used within a RecruiterProvider');
    }
    return context;
};